import React, { useEffect, useRef } from "react";
import { Box, Text, HStack, IconButton, Spacer } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import Translate from "../../components/LanguageTranslation/Translate";
import { Loader } from "@googlemaps/js-api-loader";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const GoogleMapsLink = ({ latitude, longitude, setView  }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: "AIzaSyBFvxPFaAvl37cNAwlZgHkMyGQqGWjcyik",
      version: "weekly",
    });

    loader
      .load()
      .then(() => {
        if (!window.google) {
          console.error("Google Maps API failed to load.");
          return;
        }

        const google = window.google;

        const map = new google.maps.Map(mapRef.current, {
          center: { lat: latitude, lng: longitude },
          zoom: 10,
        });

        new google.maps.Marker({
          position: { lat: latitude, lng: longitude },
          map: map,
        });
      })
      .catch((error) => {
        console.error("Error loading Google Maps API:", error);
      });
  }, [latitude, longitude]);

  const handleCloseDetail = () => {
    setView(null);
  };
  return (
    <Box>
      {" "}
      <HStack justifyContent="space-between" bg="white">
        <Box
          flex="1"
          display="flex"
          justifyContent="left"
          p={4}
          pt={2}
          pb={2}
          pl={4}
          maxH="8vh"
          borderBottom="1px"
          borderLeft="1px"
          borderColor="blackAlpha.200"
        >
          <Text
            fontSize="md"
            fontWeight="bold"
            mt={1}
            pb={2}
            color="blackAlpha.700"
          >
            <Translate text="Map" />
          </Text>
          <Spacer />
          <IconButton
            icon={<CloseIcon boxSize={2.5} />}
            onClick={handleCloseDetail}
            colorScheme="gray"
            size="sm"
            isRound={true}
            position="relative"
            zIndex="tooltip"
            bg="white"
            boxShadow="md"
          />
        </Box>
      </HStack>
      <Box h={{ base: "91vh", md: "89vh", lg: "89vh" }}>
        <div ref={mapRef} style={containerStyle}></div>
      </Box>
    </Box>
  );
};

export default GoogleMapsLink;
